import DetailTransfer from './DetailTransfer.vue';

export default DetailTransfer;